import React, { Component } from 'react'
import flatpickr from "flatpickr"
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'

class Datepicker extends Component {

    componentDidMount() {
        this.datepicker = flatpickr(document.querySelector('.datepicker'), { 
            locale: Portuguese,
            defaultDate: this.props.defaultDate ? this.props.defaultDate : null,
            altFormat: 'd/m/Y',
            altInput: true,
            mode: 'range',
            appendTo: document.querySelector('.datepicker-container'),
            onClose: (selectedDates) => this.props.onChange ? this.props.onChange(selectedDates) : null
        })
    }

    componentWillUnmount() {
        this.datepicker.destroy()
    }

    render() {
        return (            
            <div className="datepicker-container">
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1"><i className="fa fa-calendar"></i></span>
                    </div>
                    <input type="text" className="form-control datepicker" name="datepicker" placeholder="Selecione as datas" autoComplete="off" />
                </div>
            </div>
        )
    }

}

export default Datepicker